export interface IPushNotification {
  id: number;
  producerId: number;
  meetingId: number;
  text: string;
  isViewed: boolean;
  creatingDate: Date;
  notificationEventType: TNotification;
  pushType: TPushNotification;
  hashMeetingId: string;
  hashConsumerId: string;
  isAnswered: boolean;
  additionalText?: string[];
}

export const convertPushResponseToNotification = (resp: IPushResponse): IPushNotification => (
  { ...resp, creatingDate: new Date(resp.creatingDate) }
)

export interface IPushResponse {
  id: number;
  isAnswered: boolean;
  producerId: number;
  meetingId: number;
  text: string;
  isViewed: boolean;
  creatingDate: string;
  notificationEventType: TNotification;
  pushType: TPushNotification;
  hashMeetingId: string;
  hashConsumerId: string;
}

export type TNotification = 'CREATE_MEETING' | 'UPDATE_MEETING' | 'DELETE_MEETING' | 'EMAIL_VERIFICATION' | 'COUNTER_OFFER';
export type TPushNotification = 'MEETING' | 'INFORMATION' | 'PERSON';